var _path, _path2, _path3, _path4, _path5, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 869,
    height: 530,
    viewBox: "0 0 869 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.766 188.771V102.91L335.643 167.818C364.69 190.591 370.2 223.74 369.519 222.911C350.608 199.415 325.352 189.104 307.965 188.828L251.766 188.771Z",
    fill: "#FF9C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M477.761 207.301H415V434.393H477.761V207.301Z",
    fill: "#FF5A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M587.792 100.09H525.031V434.394H587.792V100.09Z",
    fill: "#FF5A0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M697.778 100.09H635.018V434.394H697.778V100.09Z",
    fill: "#FF5A0A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M306.704 355.941C306.704 366.057 297.929 374.36 288.009 374.36H234.441V266.27H288.009C297.991 266.27 306.704 274.476 306.704 284.688V355.941ZM234.859 207.374V100.227H172.415V434.361H303.09C339.852 434.361 369.635 403.089 369.635 364.489V277.246C369.635 238.646 339.852 207.374 303.09 207.374H234.859Z",
    fill: "#FF5A0A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 134,
    r: 41,
    fill: "#FF5A0A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillCom);
export default __webpack_public_path__ + "static/media/BillCom.00668e4f5079590e0fdb44a48cd1df76.svg";
export { ForwardRef as ReactComponent };